import React from "react";
import { useApp } from "@/context/AppContext";
import { CheckCircle2, Award } from "lucide-react";
import { Link } from "react-router-dom";

const About = () => {
  const { t } = useApp();
  return (
    <main data-testid="about-page" className="bg-[#0A0E1A] pt-32 pb-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Portrait */}
          <div className="lg:col-span-5">
            <div className="relative aspect-[3/4] overflow-hidden border border-[#C9A84C]/20">
              <img
                src="https://images.pexels.com/photos/3137050/pexels-photo-3137050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700"
                alt="Independent advisor portrait placeholder"
                className="w-full h-full object-cover grayscale-[20%]"
              />
              <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-[#0A0E1A] to-transparent">
                <p className="font-display text-2xl text-[#F5F0E8]">Mr. Real Estate Agent</p>
                <p className="text-xs text-[#C9A84C] tracking-[0.22em] uppercase mt-1">
                  Independent Advisor
                </p>
              </div>
            </div>
            <div className="mt-6 border border-[#C9A84C]/20 p-6 bg-[#1E2235]/40">
              <div className="flex items-center gap-3 mb-3">
                <Award className="w-5 h-5 text-[#C9A84C]" />
                <p className="overline">{t("about_rera")}</p>
              </div>
              <p className="font-display text-2xl text-[#F5F0E8]">RERA #00000</p>
              <p className="text-xs text-[#A0A5B5] mt-1 italic">(placeholder)</p>
              <div className="gold-divider my-5" />
              <p className="overline">{t("about_languages")}</p>
              <p className="mt-3 text-[#F5F0E8]/85 font-light text-sm leading-relaxed">
                {t("about_lang_list")}
              </p>
            </div>
          </div>

          {/* Story */}
          <div className="lg:col-span-7">
            <p className="overline">{t("about_overline")}</p>
            <h1 className="font-display text-4xl lg:text-6xl mt-4 leading-[1.05] text-[#F5F0E8]">
              {t("about_title")}
            </h1>
            <div className="mt-8 space-y-6 text-lg font-light leading-[1.85] text-[#F5F0E8]/90">
              <p>{t("about_story_1")}</p>
              <p>{t("about_story_2")}</p>
            </div>

            <div className="mt-14">
              <p className="overline">{t("about_approach_title")}</p>
              <ul className="mt-6 space-y-5">
                {[t("about_approach_1"), t("about_approach_2"), t("about_approach_3")].map(
                  (item, i) => (
                    <li
                      key={i}
                      data-testid={`approach-item-${i}`}
                      className="flex gap-4 items-start border-b border-[#C9A84C]/10 pb-5"
                    >
                      <CheckCircle2 className="w-5 h-5 text-[#C9A84C] flex-shrink-0 mt-1" />
                      <span className="text-[#F5F0E8]/85 font-light leading-relaxed">{item}</span>
                    </li>
                  )
                )}
              </ul>
            </div>

            <div className="mt-12 flex flex-wrap gap-4">
              <Link
                to="/contact"
                data-testid="about-book-cta"
                className="btn-gold px-8 py-4 text-xs tracking-[0.22em] uppercase font-medium"
              >
                {t("hero_cta_secondary")}
              </Link>
              <Link
                to="/properties"
                data-testid="about-properties-cta"
                className="btn-ghost-gold px-8 py-4 text-xs tracking-[0.22em] uppercase"
              >
                {t("nav_properties")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default About;
